import { Image, useSelector } from 'gf-ui'
import { Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { PAGINE } from '..'
import imgHome from '../../assets/images/home-senologia.jpg'
import Footer from '../../components/Footer'
import PageContainer from '../../components/PageContainer'
import { TIPI_LAYOUT } from '../../constants'
import HeaderSenologia from './components/HeaderSenologia'
import "./HomeSenologia.scss"

const HomeSenologia = ({ tipologia }) => {

    const tipoLayout = useSelector( state => state?.page?.data?.tipoLayout )

    return <PageContainer tipologia={tipologia}>
        <div className={`bg-white home-container`}>
            <HeaderSenologia subtitle="Questionario per la prevenzione del tumore del seno" />

            <section>
                { tipoLayout === TIPI_LAYOUT.PTV && (
                <Row>
                    <Col xs={12} md={6} lg={7}>
                        <div className='p-4 home-title-senologia'>
                            <h3>Il tumore della mammella oggi colpisce in italia una donna su otto.
                                L'arma vincente è la <span style={{ fontWeight: 'bold', color: 'hotpink' }}>diagnosi precoce</span>, che ci consente tassi altissimi di guarigione.
                                Ci sembra opportuno farle conoscere i principali fattori di rischio di sviluppare questa neoplasia
                                e la invitiamo pertanto a rispondere in forma anonima a questo questionario.
                                Le ricordiamo comunque che è opportuno per ogni donna a prescindere a partire dai 35 anni di età
                                di eseguire una mammografia e una ecografia con cadenza annuale ed essere seguita da un centro di senologia
                                a prescindere dal proprio rischio personale.
                            </h3>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={5} className='d-none d-md-flex'>
                        <div className='w-100 d-flex flex-row align-items-center justify-content-end'>
                            <div className='d-flex flex-column'>
                                <Image src={imgHome} style={{ width: '100%', height: 'auto', maxWidth: '350px', maxHeight: '450px' }} />
                            </div>
                        </div>
                    </Col>
                </Row>
                )}

                { tipoLayout === TIPI_LAYOUT.RM1 && (
                    <div className='home-senologia-rm1'>
                        <Row className='mb-4'>
                            <Col xs={12}>                                
                                Il tumore della mammella oggi interessa circa 1 donna su 8.                                
                            </Col>
                            <Col xs={12}>                                                                 
                                La nostra arma più forte per combatterlo è la diagnosi precoce, che consente nella maggior parte dei casi la guarigione.                                
                            </Col>
                        </Row>                        
                        <Row className='mb-4'>
                            <Col>                                                                
                                Per questo, se desidera intraprendere un percorso presso la Breast Unit della Asl Roma1, le chiediamo di rispondere ad alcune semplici domande che ci aiutino a capire la presenza di eventuali fattori di rischio.                                
                            </Col>
                        </Row>
                        <Row>
                            <Col>                                                                
                                Se emergeranno elementi importanti, le proporremo un percorso diagnostico e terapeutico personalizzato, costruito insieme a lei, per garantirle la migliore tutela possibile.                                
                            </Col>
                        </Row>
                    </div>
                )}
            </section>

            <section className='my-4 py-4'>
                <Row>
                    <Col >
                        <nav className="text-center">
                            { tipoLayout === TIPI_LAYOUT.PTV && (
                                <Link to={`/${tipologia.URL}${PAGINE.QUESTIONARIO.URL(tipologia)}`} className="btn-inizia"><span>Inizia il</span><span style={{ color: 'hotpink' }}> questionario</span></Link>
                            )}
                            { tipoLayout === TIPI_LAYOUT.RM1 && (
                                <Link to={`/${tipologia.URL}${PAGINE.QUESTIONARIO.URL(tipologia)}`} className="btn-inizia btn-inizia-rm1"><span>Inizia il</span><span> Questionario</span></Link>
                            )}
                        </nav>
                    </Col>
                </Row>
            </section>

            <Footer tipologia={tipologia} />
        </div>
    </PageContainer>
}

export default HomeSenologia